import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";

const fetchManualValidationApprovers = async (activityItemCode: string): Promise<Array<string>> => {
    const { data } = await apiInputService.get(`/manual-validation/manualValidation/approvers/${activityItemCode}`);

    return data;
}

export const useManualValidationApprovers = (activityItemCode: string, options?: any) => {
    const { subscription } = useSubscription();

    return useQuery<Array<string>>(
        ["manual-validation-approvers", activityItemCode, subscription?.subscriptionId],
        () => fetchManualValidationApprovers(activityItemCode),
        {
            ...options,
        }
    );
}